import type { ReactNode } from 'react';
import { useReveal } from '../hooks/useReveal';

/**
 * Wraps content in a scroll-revealed `<div>`. Extra `className`s are merged so
 * the wrapper can also be the styled element (e.g. `className="stat"` or
 * `"card"`). `delay` (1–5) applies a stagger class so grid items animate in
 * sequence.
 */
export const Reveal = ({
  children,
  className = '',
  delay = 0,
}: {
  children: ReactNode;
  className?: string;
  delay?: number;
}) => {
  const { ref, inView } = useReveal<HTMLDivElement>();
  const delayCls = delay ? ` d${Math.min(delay, 5)}` : '';
  return (
    <div ref={ref} className={`reveal${delayCls} ${className}${inView ? ' in' : ''}`.trim()}>
      {children}
    </div>
  );
};
